module.exports = __webpack_public_path__ + "img/vuejs.40282fc2.png";